module.exports = __webpack_public_path__ + "img/sales-statistics.be6b0fad.svg";